import dynamicfunction from '../utils/dynamicfunction';
import { useDispatch } from 'react-redux';
import { languages } from '../config/config';
import { setLanguage } from '../store/slices/contentSlice';
import { ReactSVG } from 'react-svg';
import icons from '../constants/icons';
import { cn } from '../utils/utils';

const Language = ({ color, lineColor, arabicIcon, isDisabled }) => {
  const { isArabic } = dynamicfunction();

  const dispatch = useDispatch();

  const handleLanguage = (languageId) => {
    dispatch(
      setLanguage({
        language: languageId == 1 ? languages?.eng : languages?.arb,
      }),
    );
  };

  return (
    <div className='flex items-center gap-2 sm:gap-4'>
      <span
        className={cn('text-[12px] cursor-pointer avenir-heavy', color || 'text-primary-dark', isArabic ? 'opacity-40' : '', isDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer')}
        onClick={() => !isDisabled && handleLanguage(1)}
      >
        EN
      </span>
      <div className={cn('w-[2px] h-6', lineColor ?? 'bg-primary-dark')} />
      <ReactSVG src={arabicIcon ?? icons.arabic_lang_icon} className={cn(!isArabic ? 'opacity-40' : '', isDisabled ? 'cursor-not-allowed' : 'cursor-pointer')} onClick={() => !isDisabled && handleLanguage(2)} />
    </div>
  );
};

export default Language;
